/**
 * The redirect for the retired questionnaire-builder path. No imports, so the
 * route tables that use it pull nothing else of the visitor feature into
 * their bundle, and its spec runs under both runners.
 */

/**
 * Where an old questionnaire-builder link lands (Brad, 25 Sep 2026: the
 * questionnaire belongs to its visitor type, so the builder is that type's
 * Questionnaire tab). `?reason=&type=` becomes
 * `<base>/reasons/<reason>?tab=questionnaire&half=<type>`; with no reason,
 * the visitor types list. `keep` names other query params to carry across
 * (the preview's `as`).
 */
export function questionnaireTabRedirect(
  base: string,
  queryParams: Readonly<Record<string, unknown>>,
  keep: readonly string[] = [],
): string {
  const text = (key: string): string => {
    const value = queryParams[key];
    return typeof value === 'string' ? value : '';
  };
  const query = new URLSearchParams();
  const reason = text('reason');
  if (reason) {
    query.set('tab', 'questionnaire');
    if (text('type')) query.set('half', text('type'));
  }
  for (const key of keep) if (text(key)) query.set(key, text(key));
  const path = reason ? `${base}/reasons/${encodeURIComponent(reason)}` : `${base}/reasons`;
  const search = query.toString();
  return search ? `${path}?${search}` : path;
}
